import React from 'react';
import { Alert, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const { Paragraph, Title, Text } = Typography;

/**
 * Component for displaying subscription policy warning before account creation
 */
const SubscriptionPolicyWarning = () => {
  return (
    <Alert
      message={
        <Title level={5} style={{ margin: 0, color: '#d4b106' }}>
          添加账号自动订阅提醒
        </Title>
      }
      description={
        <>
          <Paragraph style={{ marginBottom: 10 }}>
            封控严格，现在创建账号，会直接根据你账号里的号码数量先扣款。就相当于把你们这些号码都直接订阅上了。
          </Paragraph>
          <Paragraph strong style={{ marginBottom: 0 }}>
            例如：pingme账号里有30个号码，添加该账号时，系统会自动订阅全部30个号码并扣款。如余额不足，账号将无法使用，需联系管理员充值。
          </Paragraph>
        </>
      }
      type="warning"
      showIcon
      icon={<WarningOutlined style={{ fontSize: 20 }} />}
      style={{ 
        marginBottom: 16, 
        padding: '12px 16px',
        border: '1px solid #ffe58f',
        backgroundColor: '#fffbe6'
      }}
    />
  );
};

export default SubscriptionPolicyWarning; 